import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import _extends from 'babel-runtime/helpers/extends';

import SearchBar from '@/components/SearchV3/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import TableList from '@/components/TableList/index.vue';
import AdvertisersDialog from './components/dialog/advertisers-dialog.vue';
import { getCreativePlanList } from '@/api/creative/report';
import searchMixin from '@/mixin/search';
import AdvertiserSelector from '@/components/AllAdvertiserSelector/index.vue';
import { advWarningAdvertiser, updateUserReview, delAdvWarning } from '@/api/advertiser/manage';
import { IsUseReviewEnum, searchOptions } from '@/api/creative/warning';
import _ from 'lodash';

var defaultDialogQuery = {
  adv_names: [],
  is_use_review: IsUseReviewEnum.NO,
  is_use_rereview: IsUseReviewEnum.NO,
  upd_review: true // 更新复审-true/巡审-false
};

export default {
  components: {
    SearchBar: SearchBar,
    Pagination: Pagination,
    TableList: TableList,
    AdvertisersDialog: AdvertisersDialog
  },
  mixins: [searchMixin],
  data: function data() {
    return {
      query: {
        page: 1,
        page_size: 15,
        search_field: 'name',
        keyword: '',
        is_use_review: '',
        is_use_rereview: ''
      },
      dialogQuery: _extends({}, defaultDialogQuery),
      dialogQueryRule: {
        adv_names: {
          check: function check(value) {
            if (value.length < 1) return false;
            return true;
          }
        }
      },
      dialogEditAdv: null,
      pagination: {
        total: 0
      },
      listLoading: true,
      keyFieldConfig: [{
        value: 'adv_id',
        label: '广告主ID'
      }, {
        value: 'name',
        label: '广告主名称'
      }],
      list: [],
      tableConfig: {
        'row-key': 'adv_id'
      },
      advertisersDialog: {
        visible: false,
        title: '添加风险广告主'
      }
    };
  },

  computed: {
    tableColumnConfig: function tableColumnConfig() {
      return [{
        label: '广告主ID',
        prop: 'adv_id'
      }, {
        label: '广告主名称',
        prop: 'name'
      }, {
        label: 'BD',
        prop: 'bd'
      }, {
        label: 'BD_AM',
        prop: 'bd_am'
      }, {
        slot: 'pm-cell'
      }, {
        label: '修改人',
        prop: 'admin_name'
      }, {
        label: '是否对复审生效',
        prop: 'is_use_review',
        params: {
          innerText: function innerText(_ref) {
            var row = _ref.row;

            return row.is_use_review === IsUseReviewEnum.YES ? '是' : '否';
          }
        }
      }, {
        label: '是否对巡审生效',
        prop: 'is_use_rereview',
        params: {
          innerText: function innerText(_ref2) {
            var row = _ref2.row;

            return row.is_use_rereview === IsUseReviewEnum.YES ? '是' : '否';
          }
        }
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }];
    },
    formItemList: function formItemList() {
      var _this = this;

      var nameKeywordSearchItem = {
        prop: 'keyword',
        type: 'business',
        subtype: 'advertiser-selector',
        params: {
          filterable: true,
          valueKey: 'name',
          clearable: true
        }
      };
      var otherKeywordSearchItem = {
        prop: 'keyword',
        type: 'input',
        params: function params(_ref3) {
          var formValue = _ref3.formValue;

          return {
            disabled: false,
            readonly: false,
            clearable: true,
            style: 'width: 220px;',
            placeholder: formValue.search_field ? '按' + _this.keyFieldConfig.find(function (item) {
              return item.value === formValue.search_field;
            }).label + '搜索' : '请输入搜索内容'
          };
        }
      };
      var keywordItem = this.query.search_field === 'name' ? nameKeywordSearchItem : otherKeywordSearchItem;

      var list = {
        search_field: {
          type: 'select',
          prop: 'search_field',
          params: {
            clearable: false,
            filterable: true,
            style: 'width: 220px;',
            placeholder: '请选择搜索类型',
            options: this.keyFieldConfig,
            handleChange: function handleChange(val) {
              _this.query.keyword = '';
            }
          }
        },
        keywordItem: keywordItem,
        is_use_review: {
          type: 'select',
          prop: 'is_use_review',
          params: {
            clearable: true,
            placeholder: '是否对复审生效',
            options: searchOptions
          }
        },
        is_use_rereview: {
          type: 'select',
          prop: 'is_use_rereview',
          params: {
            clearable: true,
            placeholder: '是否对巡审生效',
            options: searchOptions
          }
        }
      };
      return list;
    },
    dialogSchema: function dialogSchema() {
      var defaultProperties = {
        is_use_review: {
          title: '是否对复审生效：',
          component: 'select',
          visible: this.dialogEditAdv === null || this.dialogQuery.upd_review,
          rules: [{
            required: true,
            message: '请选择是否对复审生效'
          }],
          field: {
            style: 'width: 300px;',
            options: searchOptions
          }
        },
        is_use_rereview: {
          title: '是否对巡审生效：',
          component: 'select',
          visible: this.dialogEditAdv === null || !this.dialogQuery.upd_review,
          rules: [{
            required: true,
            message: '请选择是否对巡审生效'
          }],
          field: {
            style: 'width: 300px;',
            options: searchOptions
          }
        }
      };
      var properties = {};
      if (this.dialogEditAdv === null) {
        properties = _Object$assign({
          adv_names: {
            title: '广告主名称：',
            component: AdvertiserSelector,
            rules: [{
              required: true,
              message: '请输入广告主名称'
            }],
            field: {
              clearable: true,
              multiple: true,
              filterable: true,
              collapseTags: true,
              valueKey: 'name',
              style: 'width: 300px;',
              placeholder: '请输入广告主名称'
            }
          }
        }, defaultProperties);
      } else {
        properties = _Object$assign({
          adv_names: {
            title: '广告主名称：',
            component: AdvertiserSelector,
            field: {
              multiple: true,
              disabled: true,
              valueKey: 'name',
              style: 'width: 300px;'
            }
          }
        }, defaultProperties);
      }

      return { type: 'object', properties: properties };
    }
  },
  watch: {
    $route: function $route() {
      this.renderList();
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.renderList();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },


  methods: {
    renderList: function renderList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.listLoading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return getCreativePlanList(_this3.query);

              case 4:
                res = _context2.sent;

                _this3.list = _.get(res, 'data.data.list') || [];
                _this3.pagination.total = _.get(res, 'data.data.total');
                _this3.listLoading = false;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](1);

                _this3.listLoading = false;

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 10]]);
      }))();
    },
    handleAddAdvertisers: function handleAddAdvertisers() {
      this.dialogEditAdv = null;
      this.advertisersDialog.title = '添加风险广告主';
      this.dialogQuery = _extends({}, defaultDialogQuery);
      this.advertisersDialog.visible = true;
    },
    handleEditReviewRule: function handleEditReviewRule(row, upd_review) {
      this.dialogEditAdv = row;
      this.dialogQuery.upd_review = upd_review;
      this.dialogQuery.adv_names = [row.name];

      if (upd_review) {
        this.advertisersDialog.title = '修改对复审生效';
        this.dialogQuery.is_use_review = row.is_use_review;
      } else {
        this.advertisersDialog.title = '修改对巡审生效';
        this.dialogQuery.is_use_rereview = row.is_use_rereview;
      }

      this.advertisersDialog.visible = true;
    },
    handleDeleteAdvertisers: function handleDeleteAdvertisers(name) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _ref4, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return delAdvWarning([name]);

              case 3:
                _ref4 = _context3.sent;
                data = _ref4.data;

                if (data.code === 0) {
                  _this4.renderList();
                }
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 8]]);
      }))();
    },
    handleAddWarningAdv: function handleAddWarningAdv() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _params, params;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (!(_this5.dialogEditAdv === null)) {
                  _context4.next = 6;
                  break;
                }

                _params = _extends({}, _.pick(_this5.dialogQuery, ['adv_names', 'is_use_review', 'is_use_rereview']));
                _context4.next = 5;
                return advWarningAdvertiser(_params);

              case 5:
                return _context4.abrupt('return', _context4.sent);

              case 6:
                params = _extends({}, _this5.dialogQuery);


                if (_this5.dialogQuery.upd_review) {
                  delete params.is_use_rereview;
                } else {
                  delete params.is_use_review;
                }
                _context4.next = 10;
                return updateUserReview(params);

              case 10:
                return _context4.abrupt('return', _context4.sent);

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4['catch'](0);

                console.log(_context4.t0);
                return _context4.abrupt('return', _context4.t0);

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 13]]);
      }))();
    }
  }
};